import { useState, useRef } from 'react';
const usePreQuestion = () => {
    const canClickRef = useRef(true);
    const [canClick, changeCanClick] = useState(true);
    const setCanClick = (params) => {
        canClickRef.current = params;
        changeCanClick(params);
    };
    return {
        canClick,
        canClickRef,
        setCanClick
    };
};

export default usePreQuestion;
